function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { log, clearLoggingData } from './utils/loggingUtil';
import { setFeatureToggles, getFeatureToggle } from './utils/featureTogglesUtils';
import { IS_CLIENT } from './utils/browserUtils';
import { resetViewId } from './guidGenerator';
import renderAd from './renderAd';
import { generateCreateAd } from './createAd';
import clearAdContext from './cleaner';
import withAdvertTargeting from './targeting';
import startPrebidBidding from './api/startPrebidBidding';
import { clearPrebidState } from './generator/prebid';
import markPageTransition from './tracking/markPageTransition';
var Advertorial = {
  allAds: []
};

Advertorial.startPrebidBidding = function (adUnits, options) {
  return startPrebidBidding(adUnits, _objectSpread(_objectSpread({}, options), {}, {
    isDemandManagerTest: getFeatureToggle('demandManagerTest')
  }));
};

Advertorial.createAdWithDataLayer = function (options) {
  if (!options.dataLayer || !options.appName) {
    log('Missing required fields "dataLayer" and/or "appName"');
    return;
  }

  Advertorial.createAd(withAdvertTargeting(options));
};

Advertorial.createAd = generateCreateAd(Advertorial);
Advertorial.renderAd = renderAd;

Advertorial.refreshView = function () {
  resetViewId();
  Advertorial.allAds = [];
  clearAdContext();
  clearPrebidState();
  clearLoggingData();
  markPageTransition();
};

var featureToggles = ['sasStaging', 'demandManagerTest'];
IS_CLIENT && setFeatureToggles(featureToggles);
export default Advertorial;
//# sourceMappingURL=advertorial.js.map